import { Box, keyframes, useBreakpointValue } from '@chakra-ui/react'
import _ from 'lodash'

import { BuyOptions } from 'src/components/features/ItListDetails'
import FooterOverlay from 'src/components/features/ItListDetails/FooterOverlay/FooterOverlay'
import BrandButton from 'src/components/widgets/buttons/BrandButton'
import { asPrice } from 'src/lib/utils'
import { BrandColor } from 'src/types'

const bounceKeyframes = (maxScale: string) => keyframes`
0% { transform: scale(1) }
94% {transform: scale(1)}
97% {transform: scale(${maxScale})}
100% { transform: scale(1) }
`

const BuyButton: React.FC<{
  creatorFirstName: string
  price: number
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
  brandColor: BrandColor
}> = ({ creatorFirstName, price, buy, buyIsLoading, brandColor }) => {
  const isSmMd = useBreakpointValue({ sm: true, lg: false })

  if (isSmMd === undefined) return null

  const PriceButton = (
    <BrandButton
      animation={{
        base: `${bounceKeyframes('1.06')} 5s ease-in-out 3`,
        md: `${bounceKeyframes('1.04')} 5s ease-in-out 3`,
      }}
      brandColor={brandColor}
      borderRadius="full"
      data-testid="itListCard-buy-button"
      w="full"
      flex={1}
      isLoading={buyIsLoading}
      onClick={() => {
        buy()
      }}
    >
      {price
        ? `Get this ItList - ${asPrice(price)}`
        : `View ${creatorFirstName}'s ItList`}
    </BrandButton>
  )

  return isSmMd ? (
    <FooterOverlay>{PriceButton}</FooterOverlay>
  ) : (
    <Box mb={6}>{PriceButton}</Box>
  )
}

export default BuyButton
